import styled from 'styled-components';
import { BackButtonLink } from 'modules/BackPageButton/styles';
import { DEVICES } from '_constants';

export const MainWrapper = styled.div`
  margin: 30px 20px 45px;

  ${BackButtonLink} {
    margin-bottom: 16px;
  }
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: var(--dim-grey);
  margin-bottom: 28px;
`;

export const Form = styled.form`
  > button {
    min-width: 160px;
  }
`;

export const FormRow = styled.div`
  width: fit-content;
  display: flex;
  flex-flow: ${({ isColumn }) => (isColumn ? 'column nowrap' : 'row nowrap')};
  justify-content: space-between;
  margin-bottom: 28px;
  gap: 10px;

  label,
  > div {
    max-width: 300px;
    min-width: 300px;
  }

  .BaseSelect__multi-value__remove {
    padding: 4px;
  }
  .BaseSelect__control {
    min-height: 38px;
  }

  @media ${DEVICES.laptop} {
    flex-flow: column nowrap;
  }

  > * {
    flex: 1 0;
    max-width: calc(50% - 8px);
    margin: 0;
  }
`;

export const RadioWrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 28px;
`;

export const Label = styled.span`
  display: inline-block;
  margin-bottom: 8px;
  font-size: 14px;
  min-width: 150px;
`;

export const PickerWrapper = styled.div`
  width: fit-content;
  display: flex;
  @media ${DEVICES.laptop} {
    flex-flow: column nowrap;
  }

  > div {
    max-width: 300px;
    min-width: 300px;
  }
`;

export const ExportWrapper = styled.div`
  > div {
    max-width: 150px;
    min-width: 150px;
  }
  div:hover {
    cursor: pointer;
  }
`;
